module.exports = __webpack_public_path__ + "icon-tw.76d6386d43ad47a773df.png";


//////////////////
// WEBPACK FOOTER
// /home/runner/work/ucla-prrla/ucla-prrla/ucla-prrla/src/assets/img/icon-tw.png
// module id = ../../../../../src/assets/img/icon-tw.png
// module chunks = 2